import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { SERVER_URL } from '../utils/api';

const Cart = () => {
  const { cart, loading, removeFromCart, updateCartItem, getCartTotal } = useCart();
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="container" style={{ 
        padding: window.innerWidth <= 768 ? '2rem 1rem' : '4rem 1rem', 
        textAlign: 'center' 
      }}>
        <span style={{
          fontSize: window.innerWidth <= 768 ? '1rem' : '1.1rem'
        }}>Cargando carrito...</span>
      </div>
    );
  }

  if (!cart || !cart.items || cart.items.length === 0) {
    return (
      <div className="container" style={{ 
        padding: window.innerWidth <= 768 ? '2rem 1rem' : '4rem 1rem', 
        textAlign: 'center' 
      }}>
        <h2 style={{
          fontSize: window.innerWidth <= 768 ? '1.5rem' : '2rem',
          marginBottom: '1rem'
        }}>Tu carrito está vacío</h2>
        <Link to="/products" style={{ 
          color: '#667eea', 
          fontSize: window.innerWidth <= 768 ? '1rem' : '1.1rem',
          textDecoration: 'none',
          fontWeight: '500'
        }}>Ver Productos</Link>
      </div>
    );
  }

  const total = getCartTotal();

  return (
    <div className="container" style={{ 
      padding: window.innerWidth <= 768 ? '1rem 0.5rem' : '2rem 1rem', 
      minHeight: '70vh' 
    }}>
      <h1 style={{ 
        marginBottom: '2rem',
        fontSize: window.innerWidth <= 768 ? '1.5rem' : '2rem',
        textAlign: window.innerWidth <= 768 ? 'center' : 'left'
      }}>Carrito de Compras</h1>

      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: '1fr', 
        gap: '2rem', 
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        <div>
          {cart.items.map((item, index) => (
            <div key={`${item.productId}-${item.size}-${item.color}-${index}`} style={{
              display: 'flex',
              flexDirection: window.innerWidth <= 768 ? 'column' : 'row',
              gap: window.innerWidth <= 768 ? '0.75rem' : '1rem',
              padding: window.innerWidth <= 768 ? '1rem' : '1.5rem',
              background: 'white',
              borderRadius: '12px',
              marginBottom: '1rem',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}>
              {item.product?.images?.[0] && (
                <div style={{
                  display: 'flex',
                  justifyContent: window.innerWidth <= 768 ? 'center' : 'flex-start'
                }}>
                  <img
                    src={`${SERVER_URL}${item.product.images[0]}`}
                    alt={item.product.name}
                    style={{ 
                      width: window.innerWidth <= 768 ? '120px' : '100px', 
                      height: window.innerWidth <= 768 ? '120px' : '100px', 
                      objectFit: 'cover', 
                      borderRadius: '8px' 
                    }}
                  />
                </div>
              )}
              <div style={{ 
                flex: 1,
                textAlign: window.innerWidth <= 768 ? 'center' : 'left'
              }}>
                <h3 style={{
                  margin: '0 0 0.5rem 0',
                  fontSize: window.innerWidth <= 768 ? '1.1rem' : '1.25rem'
                }}>{item.product?.name || 'Producto'}</h3>
                <div style={{ margin: '0.5rem 0' }}>
                  {item.product?.discount > 0 ? (
                    <div style={{
                      display: 'flex',
                      flexDirection: window.innerWidth <= 768 ? 'column' : 'row',
                      alignItems: window.innerWidth <= 768 ? 'center' : 'flex-start',
                      gap: window.innerWidth <= 768 ? '0.25rem' : '0.5rem'
                    }}>
                      <span style={{ 
                        color: '#667eea', 
                        fontSize: window.innerWidth <= 768 ? '1rem' : '1.1rem', 
                        fontWeight: '600' 
                      }}>
                        ${((item.product?.finalPrice || item.product?.price * (1 - (item.product?.discount || 0) / 100)) * item.quantity).toFixed(2)}
                      </span>
                      <span style={{ 
                        color: '#999', 
                        textDecoration: 'line-through', 
                        fontSize: '0.85rem' 
                      }}>
                        ${(item.product?.price * item.quantity).toFixed(2)}
                      </span>
                      <span style={{ 
                        background: '#ef4444', 
                        color: 'white', 
                        padding: '2px 8px', 
                        borderRadius: '4px', 
                        fontSize: '0.75rem', 
                        fontWeight: '600' 
                      }}>
                        -{item.product?.discount}%
                      </span>
                    </div>
                  ) : (
                    <p style={{ 
                      color: '#666',
                      margin: 0,
                      fontSize: window.innerWidth <= 768 ? '1rem' : '1.1rem'
                    }}>${(item.product?.price * item.quantity).toFixed(2)}</p>
                  )}
                </div>
                {item.size && <p style={{ 
                  fontSize: '0.85rem', 
                  color: '#888', 
                  margin: '0.25rem 0' 
                }}>Talla: {item.size}</p>}
                {item.color && <p style={{ 
                  fontSize: '0.85rem', 
                  color: '#888', 
                  margin: '0.25rem 0' 
                }}>Color: {item.color}</p>}

                <div style={{ 
                  display: 'flex', 
                  flexDirection: window.innerWidth <= 768 ? 'column' : 'row',
                  gap: window.innerWidth <= 768 ? '0.75rem' : '1rem', 
                  marginTop: '1rem', 
                  alignItems: window.innerWidth <= 768 ? 'center' : 'center'
                }}>
                  <input
                    type="number"
                    min="1"
                    value={item.quantity}
                    onChange={(e) => updateCartItem(item.productId, parseInt(e.target.value), item.size, item.color)}
                    style={{ 
                      width: window.innerWidth <= 768 ? '100px' : '80px', 
                      padding: '0.5rem', 
                      borderRadius: '6px', 
                      border: '1px solid #ddd',
                      fontSize: '1rem',
                      textAlign: 'center'
                    }}
                  />
                  <button
                    onClick={() => removeFromCart(item.productId, item.size, item.color)}
                    style={{
                      padding: window.innerWidth <= 768 ? '0.75rem 1.5rem' : '0.5rem 1rem',
                      background: '#ef4444',
                      color: 'white',
                      border: 'none',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      fontSize: window.innerWidth <= 768 ? '0.9rem' : '0.85rem',
                      fontWeight: '500'
                    }}
                  >
                    Eliminar
                  </button>
                </div>
              </div>
              {window.innerWidth > 768 && (
                <div style={{ 
                  fontWeight: 'bold', 
                  fontSize: '1.2rem',
                  minWidth: '120px',
                  textAlign: 'right'
                }}>
                  {item.product?.discount > 0 ? (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                      <span style={{ color: '#667eea' }}>
                        ${((item.product?.finalPrice || item.product?.price * (1 - (item.product?.discount || 0) / 100)) * item.quantity).toFixed(2)}
                      </span>
                      <span style={{ color: '#999', textDecoration: 'line-through', fontSize: '0.9rem', fontWeight: 'normal' }}>
                        ${((item.product?.price || 0) * item.quantity).toFixed(2)}
                      </span>
                    </div>
                  ) : (
                    <span>${((item.product?.price || 0) * item.quantity).toFixed(2)}</span>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>

        <div style={{
          background: 'white',
          padding: window.innerWidth <= 768 ? '1.5rem' : '2rem',
          borderRadius: '12px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          height: 'fit-content',
          margin: window.innerWidth <= 768 ? '0 0.5rem' : '0'
        }}>
          <h2 style={{ 
            marginBottom: '1.5rem',
            fontSize: window.innerWidth <= 768 ? '1.25rem' : '1.5rem',
            textAlign: window.innerWidth <= 768 ? 'center' : 'left'
          }}>Resumen</h2>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            fontSize: window.innerWidth <= 768 ? '1.1rem' : '1.25rem', 
            fontWeight: 'bold',
            marginBottom: window.innerWidth <= 768 ? '1rem' : '0'
          }}>
            <span>Total:</span>
            <span>${total.toFixed(2)}</span>
          </div>

          <button
            onClick={() => navigate('/checkout')}
            style={{
              width: '100%',
              padding: window.innerWidth <= 768 ? '1.25rem' : '1rem',
              marginTop: '1.5rem',
              background: '#03355A',
              color: 'white',
              border: 'none',
              borderRadius: '10px',
              fontSize: window.innerWidth <= 768 ? '1.1rem' : '1rem',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            Proceder al Pago
          </button>
        </div>
      </div>
    </div>
  );
};

export default Cart;
